import React from 'react'
import { connect } from 'react-redux'
import auth from '../../common/auth'
import { Translate, getTranslate } from 'react-localize-redux'
import acceptCertificateImg from '../../assets/images/acceptCertificate.png'
import {
	connectQzTray,
	getSpecificPrinter
} from '../../common/qz/qzTrayService'
import AbstractSetupPart from './AbstractSetupPart'

class PrinterCheck extends AbstractSetupPart {
	constructor(props) {
		super(props)
		this.state = {
			qz: {
				printerSetup: { status: 'upcoming' }
			}
		}
	}

	componentDidMount() {
		this.props.registerCallback(
			this.processCheck.bind(this),
			this.resetCheck.bind(this)
		)
	}

	processCheck() {
		let newState = this.state
		newState.qz.printerSetup.status = 'in-progress'
		newState.qz.printerSetup.message = this.props.translate(
			'stationSetup.controller.LOKKING_FOR_PRINTER'
		)
		this.setState(newState)

		return connectQzTray()
			.then(null, this.handlePrinter.bind(this))
			.then(() => {
				return getSpecificPrinter(this.props.printerName).then(
					function(printers) {
						let newState = this.state
						if (printers.length === 0) {
							newState.qz.printerSetup.status = 'failed'
							newState.qz.printerSetup.message = this.props.translate(
								'stationSetup.controller.NO_PRINTER_FOUND'
							)
						} else {
							newState.qz.printerSetup.status = 'succeeded'
							newState.qz.printerSetup.message = this.props.translate(
								'stationSetup.controller.PRINTER_FOUND'
							)
							newState.qz.printerSetup.configuredPrinters = printers
						}
						this.setState(newState)
					}.bind(this),
					this.handlePrinter.bind(this)
				)
			})
	}

	handlePrinter(err) {
		let newState = this.state
		newState.qz.printerSetup.status = 'failed'
		newState.qz.printerSetup.message = this.getErrorMessage(err)
		this.setState(newState)
		throw err
	}

	resetCheck() {
		let newState = this.state
		newState.qz.printerSetup = {
			status: 'upcoming',
			message: this.props.translate('stationSetup.controller.VERIFY_SETUP')
		}
		this.setState(newState)
	}

	render() {
		return (
			<div
				id="printer-setup"
				className={`panel ${PrinterCheck.decidePanelClassname(
					this.state.qz.printerSetup.status
				)}`}
			>
				<div className="panel-heading">
					<span
						className={`glyphicon ${PrinterCheck.decideGlyphiconClassname(
							this.state.qz.printerSetup.status
						)}`}
						aria-hidden="true"
					/>
					<span>{this.state.qz.printerSetup.message}</span>
				</div>
				{(this.state.qz.printerSetup.status === 'in-progress' ||
					this.state.qz.printerSetup.status === 'failed') && (
					<div className="panel-body">
						<p className="lead media-heading">
							{this.props.translate('stationSetup.PRINT_LABEL_1', {
								printer: this.props.printerName
							})}
						</p>
						<div className="media">
							<div className="media-left media-middle">
								<img
									className="media-object"
									src={acceptCertificateImg}
									alt="QZ certificate dialog"
								/>
							</div>
							<div className="media-body">
								<h4 className="media-heading">
									<Translate id="stationSetup.PRINT_LABEL_4" />
								</h4>
								<p>
									<Translate id="stationSetup.PRINT_LABEL_5" />
								</p>
								<p>
									<span>
										<Translate id="stationSetup.PRINT_LABEL_6" />
									</span>
								</p>
							</div>
						</div>
					</div>
				)}
			</div>
		)
	}
}

export default connect(state => ({
	isLoggedIn: auth.isLoggedIn(),
	translate: getTranslate(state.locale)
}))(PrinterCheck)



// WEBPACK FOOTER //
// ./src/components/qzSetup/PrinterCheck.js